<template>

    <div class="page p-settings">
        <the-dashboard-heading>
            <h2>Ustawienia</h2>
        </the-dashboard-heading>

        <the-dashboard-content>

            <settings-notifications></settings-notifications>
            <settings-p1-integration></settings-p1-integration>

            <settings-password></settings-password>
            <settings-offices></settings-offices>

            <settings-custom-fields></settings-custom-fields>
            <settings-transfer></settings-transfer>

            <settings-export></settings-export>
            <settings-export-calendar></settings-export-calendar>

<!--            <section class="p-settings__empty"></section>-->

        </the-dashboard-content>
    </div>

</template>


<script>

import store from 'Store'

import TheDashboardHeading from 'Components/Dashboard/TheDashboardHeading'
import TheDashboardContent from 'Components/Dashboard/TheDashboardContent'

import SettingsTransfer from 'Components/Settings/SettingsTransfer'
import SettingsExport from 'Components/Settings/SettingsExport'
import SettingsExportCalendar from 'Components/Settings/SettingsExportCalendar'
import SettingsPassword from 'Components/Settings/SettingsPassword'
import SettingsOffices from 'Components/Settings/SettingsOffices'
import SettingsCustomFields from 'Components/Settings/SettingsCustomFields'
import SettingsNotifications from 'Components/Settings/SettingsNotifications'
import SettingsP1Integration from 'Components/Settings/SettingsP1Integration'


export default {

    name: 'ViewSettings',

    beforeRouteEnter(to, from, next) {
        store.dispatch('PAGE_LOADING_SET')
        Promise.all([
            store.dispatch('PHT_FETCH'),
            store.dispatch('PHT_OFFICES_FETCH'),
            store.dispatch('PATIENTS_LIST_FETCH'),
        ]).then(() => {
            store.dispatch('PAGE_LOADING_RESET')
            next()
        })
    },

    components: {
        TheDashboardHeading,
        TheDashboardContent,
        SettingsPassword,
        SettingsNotifications,
        SettingsOffices,
        SettingsCustomFields,
        SettingsTransfer,
        SettingsExport,
        SettingsExportCalendar,
        SettingsP1Integration
    }

}
</script>


<style lang="scss">

@import '~Style/_utils.scss';

.p-settings {
    section {
        width: 50%;

        @include bp($screen-lg) {
            width: 100%;
        }
    }
    &__empty {
        @include bp($screen-lg) {
            display: none;
        }
    }
}

</style>
